"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function addDTMScriptToDOM(url, analyticsId) {
    if (typeof document === 'undefined') {
        return;
    }
    var scriptNode = document.createElement('script');
    scriptNode.src = "".concat(url, "?id=").concat(analyticsId);
    scriptNode.async = true;
    document.head.appendChild(scriptNode);
    window.dataLayer = window.dataLayer || [];
    function gtagFn() {
        // this script is provided by google, hence using arguments
        /* eslint-disable prefer-rest-params */
        window.dataLayer.push(arguments);
    }
    window.gtag = gtagFn;
    window.gtag('js', new Date());
    window.gtag('config', analyticsId);
}
function GoogleAnalytics(options) {
    var _a;
    var isAnalyticsDisabled = options.disableAnalytics;
    if (!isAnalyticsDisabled) {
        addDTMScriptToDOM(options.scriptUrl, (_a = options.analyticsID) !== null && _a !== void 0 ? _a : '');
    }
    var fireTrackingEvent = function (eventName, payload) {
        if (isAnalyticsDisabled) {
            return;
        }
        window.gtag('event', eventName, payload);
    };
    return {
        fireTrackingEvent: fireTrackingEvent,
    };
}
exports.default = GoogleAnalytics;
//# sourceMappingURL=GoogleAnalytics.js.map